import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./DigitalIndiaQuote.css";

import img1 from "./img/1_KCv0l0CEcDassW0OptliEQ.jpg";
import img2 from "./img/1_KCv0l0CEcDassW0OptliEQ.webp";

const slides = [
  {
    img: img1,
    text: `"I dream of a digital India where high-speed digital highways unite the Nation; 1.3 billion connected Indians drive innovation; technology ensures the citizen-government interface is incorruptible"`,
    signature: "— नरेंद्र मोदी",
  },
  {
    img: img2,
    text: `"Digital India is not an elite concept anymore, it is for the masses."`,
    signature: "— नरेंद्र मोदी",
  },
  {
    img: img2,
    text: `"Technology is the most powerful means to empower the poor."`,
    signature: "— नरेंद्र मोदी",
  },
];

const DigitalIndiaQuote = () => {
  return (
    <div className="slider-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="quote-container">
              <div className="quote-left">
                <img src={slide.img} alt="Leader" className="quote-image" />
              </div>
              <div className="quote-right">
                <p className="quote-text">
                  <span className="highlight">{slide.text}</span>
                </p>
                <p className="signature">{slide.signature}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DigitalIndiaQuote;
